import Vue from 'vue';
import VueRouter from 'vue-router';
import RechargePage from '../components/RechargePage.vue';
import AmountInputPage from '../components/AmountInputPage.vue';
import AmountCYInputPage from '../components/AmountCYInputPage.vue';
import AmountCYSelectOldPage from '../components/AmountCYSelectOldPage.vue';
import AmountCYSelectPage from '../components/AmountCYSelectPage.vue';
import AmountCYInputBbxkPage from '../components/AmountCYInputBbxkPage.vue';
import AmountCYInputAnyPage from '../components/AmountCYInputAnyPage.vue';
import AmountCYInputAnyPageNew from '../components/AmountCYInputAnyPageNew.vue';
import AmountCYPayTypesPage from '../components/AmountCYPayTypesPage.vue';
import AmountCYPayTypesNoNamePage from '../components/AmountCYPayTypesNoNamePage.vue';
import AmountCYInputAnyNoNamePageNew from '../components/AmountCYInputAnyNoNamePageNew.vue';
import AmountInputAnyAuto from '../components/AmountInputAnyAuto.vue';
import AmountCYInputNoNamePage from '../components/AmountCYInputNoNamePage.vue';
import QueryOrder from '../components/QueryOrder.vue';
import OpenAndClose from '../components/OpenAndClose.vue';
import MobileQueryOrder from '../components/MobileQueryOrder.vue';
import MobileQueryOrderByIp from '../components/MobileQueryOrderByIp.vue';
import ResultPage from '../components/ResultPage.vue';
import WaitPage from '../components/WaitPage.vue';
import WaitQRPage from '../components/WaitQRPage.vue';
import TestPage from '../components/TestPage.vue';
import GeTarget from '../components/GeTarget.vue';
import ShowQR from '../components/ShowQR.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/recharge',
    name: 'RechargePage',
    component: RechargePage
  },
  {
    path: '/wait',
    name: 'WaitPage',
    component: WaitPage
  },
  {
    path: '/waitqr',
    name: 'WaitQRPage',
    component: WaitQRPage
  },
  {
    path: '/amountinput',
    name: 'AmountInputPage',
    component: AmountInputPage
  },
  {
    path: '/amountinput',
    name: 'AmountInputPage',
    component: AmountInputPage
  },
  {
    path: '/amountcyinput',
    name: 'AmountCYInputPage',
    component: AmountCYInputPage
  },
  {
    path: '/amountcyselect',
    name: 'AmountCYSelectPage',
    component: AmountCYSelectPage
  },
  {
    path: '/amountcyselectold',
    name: 'AmountCYSelectOldPage',
    component: AmountCYSelectOldPage
  },
  {
    path: '/amountcyinputbbxk',
    name: 'AmountCYInputBbxkPage',
    component: AmountCYInputBbxkPage
  },
  {
    path: '/amountcyinputany',
    name: 'AmountCYInputAnyPage',
    component: AmountCYInputAnyPage
  },
  {
    path: '/amountcyinputanynew',
    name: 'AmountCYInputAnyPageNew',
    component: AmountCYInputAnyPageNew
  },
  {
    path: '/amountcypaytypes',
    name: 'AmountCYPayTypesPage',
    component: AmountCYPayTypesPage
  },
  {
    path: '/amountcypaytypesnoname',
    name: 'AmountCYPayTypesNoNamePage',
    component: AmountCYPayTypesNoNamePage
  },
  {
    path: '/amountcyinputanynonamenew',
    name: 'AmountCYInputAnyNoNamePageNew',
    component: AmountCYInputAnyNoNamePageNew
  },
  {
    path: '/amountinputanyauto',
    name: 'AmountInputAnyAuto',
    component: AmountInputAnyAuto
  },
  {
    path: '/amountcyinputnoname',
    name: 'AmountCYInputNoNamePage',
    component: AmountCYInputNoNamePage
  },
  {
    path: '/queryorder',
    name: 'QueryOrder',
    component: QueryOrder
  },
  {
    path: '/openandclose',
    name: 'OpenAndClose',
    component: OpenAndClose
  },
  {
    path: '/mobilequeryorder',
    name: 'MobileQueryOrder',
    component: MobileQueryOrder
  },
  {
    path: '/mobilequeryorderbyip',
    name: 'MobileQueryOrderByIp',
    component: MobileQueryOrderByIp
  },
  {
    path: '/result',
    name: 'ResultPage',
    component: ResultPage
  },
  {
    path: '/',
    name: 'TestPage',
    component: TestPage
  },
  {
    path: '/GeTarget',
    name: 'GeTarget',
    component: GeTarget
  } ,
  {
    path: '/showqr',
    name: 'ShowQR',
    component: ShowQR
  } 
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;